import { Css } from "@homebound/beam";

export const productCardHoverScope = "productCardHoverScope";
export const productCardHoverIcons = "productCardHoverIcons";
export const productCardHoverImageOverlay = "productCardHoverImageOverlay";

export const css = {
  [`.${productCardHoverScope}:hover .${productCardHoverIcons}`]: Css.o100.vv.top3.$,
  [`.${productCardHoverScope}:hover .${productCardHoverImageOverlay}`]: Css.o50.br8.$,
  [`.${productCardHoverScope} button:hover path`]: Css.fill("black").$,
};
